/* eslint-disable @typescript-eslint/no-explicit-any */
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setAuth, removeAuth } from "../slices/authSlice";
import { baseApi } from "../api/baseApi";
import { userApi } from "../services/userService";

// Create the listener middleware instance
export const currentUserMiddleware = createListenerMiddleware();

// Listen for setAuth action - fetch current user when authentication is set
currentUserMiddleware.startListening({
  actionCreator: setAuth,
  effect: async (action, listenerApi) => {
    try {
      // Dispatch the getCurrentUser query
      const result = await listenerApi.dispatch(
        userApi.endpoints.getCurrentUser.initiate()
      );

      // Wait for the query to complete
      await result;

      console.log("Current user fetched successfully after login");
    } catch (error) {
      console.error("Failed to fetch current user after login:", error);
    }
  },
});

// Listen for removeAuth action - clear user data when logging out
currentUserMiddleware.startListening({
  actionCreator: removeAuth,
  effect: async (action, listenerApi) => {
    try {
      // Reset the entire API state to clear all cached data
      listenerApi.dispatch(baseApi.util.resetApiState());
      
      console.log("User data cleared after logout");
    } catch (error) {
      console.error("Failed to clear user data after logout:", error);
    }
  },
});

// Also fetch current user on app initialization if token exists
export const initializeCurrentUser = () => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const token = state.auth.token;
    const expires = state.auth.expires;

    // Check if user is authenticated and token is valid
    if (token && expires && new Date(expires).getTime() > new Date().getTime()) {
      try {
        // Fetch current user
        const result = await dispatch(
          userApi.endpoints.getCurrentUser.initiate()
        );
        
        await result;
        
        console.log("Current user fetched on app initialization");
      } catch (error) {
        console.error("Failed to fetch current user on initialization:", error);
      }
    }
  };
};